import './index.css'
import './i18n'

import * as Sentry from '@sentry/react'
import { QueryClientProvider } from '@tanstack/react-query'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter as Router } from 'react-router-dom'

import App from './App'
import environment from './environment'
import { queryClient } from './lib/queryClient'
// import * as serviceWorkerRegistration from './serviceWorkerRegistration'
import store from './store/store'

if (!environment.isDev) {
  Sentry.init({
    dsn: 'https://676ec9f23a61962b3daa037e133169a0@o4508680792702976.ingest.de.sentry.io/4510097213816912',
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    environment: environment.isProd ? 'production' : environment.isDev ? 'development' : 'staging',
    sendDefaultPii: true,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({ maskAllText: false, blockAllMedia: false }),
      Sentry.consoleLoggingIntegration({ levels: ['error', 'info'] }),
    ],
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ['localhost', /^https:\/\/api\.shiptanbul\.com\/api/, /^https:\/\/api\.test\.shiptanbul\.com\/api/],
    tracesSampleRate: 1.0,
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.,
    // Enable logs to be sent to Sentry
    enableLogs: true,
    enabled: true,
  })
}
//service-worker unregister
if (window.navigator && navigator.serviceWorker) {
  navigator.serviceWorker.getRegistrations().then(function (registrations) {
    for (const registration of registrations) {
      registration.unregister()
    }
  })
}

createRoot(document.getElementById('root')!).render(
  <QueryClientProvider client={queryClient}>
    <Provider store={store}>
      <Router>
        <App />
      </Router>
    </Provider>
  </QueryClientProvider>
)
